import store from "@/store";
import _ from "lodash";

export default (to, from, next) => {
  _.get(store, 'getters.getToken', null) != null ? next("/") : next();
};
